import { Autocomplete, Box, TextField, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { UpperCasePrenomNomFromAuth } from '../../Utils/utils';
// import useGetRequest from '../../hooks/useGetRequest';
// import { axiosPrivate } from '../../Api/axios';
// import { TextFieldComponent } from './ReusableSmallComponents';
const initialUser = {
    'persoData': {
        'nom': 'sélectionner',
        'prenom': ' ...',
    },
    '_id': '1111111111111111111',
};
function SearchExpertDossierCandidat({ setUser, isDossierCandidat, width,ajouterDossierCandidat,
    variant, name, disabled }) {
    SearchExpertDossierCandidat.propTypes = {
        isDossierCandidat: PropTypes.any,
        setUser: PropTypes.func,
        ajouterDossierCandidat:PropTypes.any,

        user: PropTypes.any,
        //placeholder: PropTypes.any,
        variant: PropTypes.any,
        width: PropTypes.any,
        size: PropTypes.any,
        name: PropTypes.string,
        disabled: PropTypes.bool,
    };
    const axiosPrivate = useAxiosPrivate();

    // * in case of create mission, we must get experts liked to AO, //TODO : add the scenario ON HE BACKEND: if(selectedAoIdQuery) get only experts where their status are retained
    // const selectedAoIdQuery = selectedAoId ? `&selectedAoId=${selectedAoId}` : '';
    // const selectedCompanyId = companyId ? `&companyId=${companyId}` : '';
    const [usersList, setUsersList] = useState([]);
    // ?? { _id: '', porsoData:{nom:'' ,prenom:''}}
    let navigate = useNavigate();
    // const [userMatchesTheInputUser, setUserMatchesTheInputUser] = useState(initialUser);
    const { errors, showErrors } = useUtilities();
    const { inputSize } = useWindowSize();
    const { i18n } = useTranslation();
    const error = name in errors ? errors[name] : undefined;
    useEffect(() => {
        getUsersList();
    }, [isDossierCandidat]);

    // useEffect(() => {
    //     if (usersList) {
    //         usersList.map((element) => {
    //             if (element?._id == userId) {
    //                 // console.log('userId', userId, 'element', element?._id);
    //                 //let a=element?.persoData?.nom;
    //                 //{porsoData:{nom:element?.persoData?.nom ,prenom:element?.persoData?.prenom}}
    //                 setUserMatchesTheInputUser(element);
    //                 // console.log(element?.persoData?.nom, element?.persoData?.prenom);
    //             }
    //         });
    //     }
    // }, [usersList]);
    // useEffect(() => {
    //     if (!companyId) {
    //         setUsersList([]);
    //         setUserMatchesTheInputUser(initialUser);
    //     }
    // }, [companyId]);

    const getUsersList = async () => {
        setUsersList([]);
        // setUserMatchesTheInputUser(initialUser);
        setUser(null);
        try {
            const response = await axiosPrivate.get(`expert/getMyExperts?isDossierCandidat=${isDossierCandidat}`);
            setUsersList(response?.data);
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <Autocomplete
            id="asynchronous-demo"
            sx={{ width: width || 350 }}
            getOptionLabel={(option) => `${option?.persoData?.nom} ${option?.persoData?.prenom}`}
            options={ajouterDossierCandidat ? [...usersList, { createNew: true }] : usersList} // Add the button only if ajouterDossierCandidat is true
            disabled={disabled}
            freeSolo
            value={initialUser}
            size={inputSize}
            isOptionEqualToValue={(option, value) => option?.persoData?.nom === value?.persoData?.nom}
            onChange={(event, newValue) => {
                if (newValue?.createNew) {
                    navigate('/esn/AddExpertStep1', { state: { isCandidat: true }, replace: true });
                } else {
                    setUser(newValue);
                }
            }}
            renderOption={(props, option) => (
                <Box
                    component='li'
                    {...props}
                    key={option?._id || 'create-new'}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: option.createNew ? 'blue' : 'inherit',  // Blue text only for "Create New"
                        backgroundColor: 'inherit',  // Make sure the background is the same as other options
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',  // Use the same hover effect as regular items
                        },
                    }}
                >
                    {option.createNew ? (
                    // The "Create New" option with blue text
                        <span>Créer un nouveau dossier candidat</span>
                    ) : (
                    // Regular options display user info
                        <>
                            {UpperCasePrenomNomFromAuth(option?.persoData?.nom, option?.persoData?.prenom)}{' '}
                            {option?.expertId}
                        </>
                    )}
                </Box>
            )}
            renderInput={(params) => (
                <ThemeProvider theme={FieldComponentFont}>
                    <TextField
                        {...params}
                        sx={{
                            width: width || '350px',
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        placeholder={i18n.t('Sélectionner')}
                        variant={variant || 'outlined'}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                        }}
                        style={{ background: 'white', borderRadius: '8px' }}
                        name={name}
                        helperText={showErrors && (i18n.t(error) ?? '')}
                        error={!!error && showErrors}
                    />
                </ThemeProvider>
            )}
        />
    );
}

export default SearchExpertDossierCandidat;
{/*
// ! <AutoComplete must have the original TextField and not just the TextFieldComponent for required fields
<TextFieldComponent
                    {...params}
                    sx={{width:width || '350px',
                        '& > :not(style)': {borderRadius: '8px'},
                    }}
                    size={size || 'medium'}
                    placeholder={placeholder || userType}
                    variant={variant || 'outlined'}
                    name={name}
                /> */}